import 'owl.carousel2/dist/owl.carousel.min'
import 'lightgallery/dist/js/lightgallery-all.min'
import 'dropkickjs';

export default {
  init() {
    // JavaScript to be fired on the home page

    // Initialize YouTube iframes to enable JS API
    $('iframe').each(function() {
      const src = $(this).attr('src');
      if (src && src.includes('youtube')) {
        // Store all original attributes
        const originalIframe = $(this);
        const attributes = {};
        $.each(originalIframe[0].attributes, function(_, attr) {
          attributes[attr.name] = attr.value;
        });
        
        // Prepare the new src with proper parameters
        let newSrc = src;
        if (!newSrc.includes('enablejsapi=1')) {
          if (newSrc.includes('?')) {
            newSrc += '&enablejsapi=1&origin=' + window.location.origin;
          } else {
            newSrc += '?enablejsapi=1&origin=' + window.location.origin;
          }
        }
        
        // Create a new iframe element with all original attributes
        const iframeParent = originalIframe.parent();
        const newIframe = $('<iframe></iframe>');
        
        // Copy all original attributes
        $.each(attributes, function(key, value) {
          if (key !== 'src') { // We'll set src last
            newIframe.attr(key, value);
          }
        });
        
        // Set the updated src
        newIframe.attr('src', newSrc);
        
        // Replace the original iframe
        originalIframe.remove();
        iframeParent.append(newIframe);
      }
    });

    // FILE INPUTS filenames multiple init
    $('input[type=file]').change(function(e) {
      const fileName = e.target.files[0].name;
      const label = $(this).parents('.file-group').find('label.custom-file-label');
      const fileNumber = $(this).get(0).files.length
        if (fileNumber > 1) {
          label.html(fileNumber + ' files selected.');
        } else {
          label.html(fileName);
        }
    });

    // SELECT INPUTS styling init
    $('#partner-select').dropkick();
    $('.classic-select .wpcf7-select').dropkick();
    $('#category-select').dropkick();


    // ------------------------
    // SCHEDULE switching
    // ------------------------

    const scheduleTypeLabelContainer = $('#schedule-type-label');
    const scheduleTypeButtons = $('#schedule-type-buttons');
    const forumSection = $('#forum-section');
    const galaSection = $('#gala-section');

    function initSchedule() {
      if (scheduleTypeButtons.length > 0) {
        $('#gala-section').hide();
        const forumLabel = $('#forum-section').attr('data-label');
        scheduleTypeLabelContainer.html(forumLabel);
        $(this).removeClass('primary-btn tertiary-btn').addClass('primary-btn');
        $('#gala-type-btn').removeClass('primary-btn').addClass('tertiary-btn');
      } else if (forumSection.length > 0) {
        const forumLabel = $('#forum-section').attr('data-label');
        scheduleTypeLabelContainer.html(forumLabel);
      } else if (galaSection.length > 0) {
        const galaLabel = $('#gala-section').attr('data-label');
        scheduleTypeLabelContainer.html(galaLabel);
      }
    }

    initSchedule();

    $('#forum-type-btn').click(function() {
      $('#forum-section').fadeIn();
      $('#gala-section').hide();
      const forumLabel = $('#forum-section').attr('data-label');
      scheduleTypeLabelContainer.html(forumLabel);
      $(this).removeClass('primary-btn tertiary-btn').addClass('primary-btn');
      $('#gala-type-btn').removeClass('primary-btn').addClass('tertiary-btn');
    });

    $('#gala-type-btn').click(function() {
      $('#gala-section').fadeIn();
      $('#forum-section').hide();
      const galaLabel = $('#gala-section').attr('data-label');
      scheduleTypeLabelContainer.html(galaLabel);
      $(this).removeClass('tertiary-btn').addClass('primary-btn');
      $('#forum-type-btn').removeClass('primary-btn').addClass('tertiary-btn');
    });

    // ------------------------
    // CAROUSEL
    // ------------------------

    $('#gallery-carousel').lightGallery();
    $('#gallery-carousel').owlCarousel({
      items: 1,
      loop: true,
      margin:25,
      nav:true,
      autoplay: true,
      lazyLoad: true,
      navText : ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
      responsive:{
        0:{
          items:1,
        },
        768:{
          items:2,
        },
        1024:{
          items:3,
        },
        1280:{
          items:4,
        },
      },
    });

    // ------------------------
    // MODALS
    // ------------------------

    // VIDEO modal - new flexible content
    $('.video-modal-btn').click(function() {
      const videoId = $(this).data('video-id');
      $(`#video-modal-${videoId}`).fadeIn();
      $('html').addClass('is-blocked');
      
      // Check if the iframe has enablejsapi parameter
      const iframe = $(`#video-modal-${videoId} .video-embed iframe`);
      if (iframe.length) {
        const src = iframe.attr('src');
        
        if (src && src.includes('youtube') && !src.includes('enablejsapi=1')) {
          let newSrc = src;
          if (src.includes('?')) {
            newSrc = src + '&enablejsapi=1&origin=' + window.location.origin;
          } else {
            newSrc = src + '?enablejsapi=1&origin=' + window.location.origin;
          }
          iframe.attr('src', newSrc);
        }
        
        // Now play the video
        setTimeout(() => {
          iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }, 500);
      }
    });

    // VIDEO modal - legacy
    $('#video-modal-btn').click(function() {
      $('#video-modal').fadeIn();
      $('html').addClass('is-blocked');
      
      // Check if the iframe has enablejsapi parameter
      const iframe = $('#video-modal .video-embed iframe');
      if (iframe.length) {
        const src = iframe.attr('src');
        
        if (src && src.includes('youtube') && !src.includes('enablejsapi=1')) {
          let newSrc = src;
          if (src.includes('?')) {
            newSrc = src + '&enablejsapi=1&origin=' + window.location.origin;
          } else {
            newSrc = src + '?enablejsapi=1&origin=' + window.location.origin;
          }
          iframe.attr('src', newSrc);
        }
        
        // Now play the video
        setTimeout(() => {
          iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }, 500);
      }
    });

    // Close video modal and pause video
    $('.modal.video-modal .close-icon, .modal.video-modal .modal-backdrop').click(function() {
      const modal = $(this).closest('.video-modal');
      modal.fadeOut();
      if ($('.modal:visible').length === 0) {
        $('html').removeClass('is-blocked');
      }
      modal.find('.video-embed iframe').each(function() {
        let iframeSrc = $(this).attr('src');
        
        if (iframeSrc && iframeSrc.includes('youtube')) {
          // Store all original attributes
          const originalIframe = $(this);
          const attributes = {};
          $.each(originalIframe[0].attributes, function(_, attr) {
            attributes[attr.name] = attr.value;
          });
          
          // Update src with required parameters
          if (!iframeSrc.includes('enablejsapi=1')) {
            if (iframeSrc.includes('?')) {
              iframeSrc += '&enablejsapi=1&origin=' + window.location.origin;
            } else {
              iframeSrc += '?enablejsapi=1&origin=' + window.location.origin;
            }
          }
          
          // Force video to stop by reloading iframe with autoplay=0
          if (iframeSrc.includes('autoplay=1')) {
            iframeSrc = iframeSrc.replace('autoplay=1', 'autoplay=0');
          } else if (!iframeSrc.includes('autoplay=')) {
            if (iframeSrc.includes('?')) {
              iframeSrc += '&autoplay=0';
            } else {
              iframeSrc += '?autoplay=0';
            }
          }
          
          // Create a new iframe element with all original attributes
          const iframeParent = originalIframe.parent();
          const newIframe = $('<iframe></iframe>');
          
          // Copy all original attributes
          $.each(attributes, function(key, value) {
            if (key !== 'src') { // We'll set src last
              newIframe.attr(key, value);
            }
          });
          
          // Set the updated src
          newIframe.attr('src', iframeSrc);
          
          // Replace the original iframe
          originalIframe.remove();
          iframeParent.append(newIframe);
        }
      });
    });

    // Close legacy video modal and pause video
    $('#video-modal .close-icon, #video-modal .modal-backdrop').click(function() {
      $('#video-modal').fadeOut();
      if ($('.modal:visible').length === 0) {
        $('html').removeClass('is-blocked');
      }
      $('#video-modal .video-embed iframe').each(function() {
        let iframeSrc = $(this).attr('src');
        
        if (iframeSrc && iframeSrc.includes('youtube')) {
          // Store all original attributes
          const originalIframe = $(this);
          const attributes = {};
          $.each(originalIframe[0].attributes, function(_, attr) {
            attributes[attr.name] = attr.value;
          });
          
          // Update src with required parameters
          if (!iframeSrc.includes('enablejsapi=1')) {
            if (iframeSrc.includes('?')) {
              iframeSrc += '&enablejsapi=1&origin=' + window.location.origin;
            } else {
              iframeSrc += '?enablejsapi=1&origin=' + window.location.origin;
            }
          }
          
          // Force video to stop by reloading iframe with autoplay=0
          if (iframeSrc.includes('autoplay=1')) {
            iframeSrc = iframeSrc.replace('autoplay=1', 'autoplay=0');
          } else if (!iframeSrc.includes('autoplay=')) {
            if (iframeSrc.includes('?')) {
              iframeSrc += '&autoplay=0';
            } else {
              iframeSrc += '?autoplay=0';
            }
          }
          
          // Create a new iframe element with all original attributes
          const iframeParent = originalIframe.parent();
          const newIframe = $('<iframe></iframe>');
          
          // Copy all original attributes
          $.each(attributes, function(key, value) {
            if (key !== 'src') { // We'll set src last
              newIframe.attr(key, value);
            }
          });
          
          // Set the updated src
          newIframe.attr('src', iframeSrc);
          
          // Replace the original iframe
          originalIframe.remove();
          iframeParent.append(newIframe);
        }
      });
    });

    // BIO modal
    $('#speakers-section .single-person').click(function() {
      $('#bio-modal').fadeIn();
      $('html').addClass('is-blocked');

      const personName = $(this).find('.person-name').html();
      const personPhotoSrc = $(this).find('.person-photo').css('background-image');
      const personPosition = $(this).find('.person-position').html();
      const personDesc = $(this).find('.person-bio').html();
      const personComapnyName = $(this).find('.person-company-name').html();
      const personCompanyLogoSrc = $(this).find('.person-company-logo').attr('src');

      const targetPersonName = $('#bio-modal').find('.person-name');
      const targetPersonPhotoSrc = $('#bio-modal').find('.person-photo');
      const targetPersonPosition = $('#bio-modal').find('.person-position');
      const targetPersonDesc = $('#bio-modal').find('.person-bio');
      const targetPersonComapnyName = $('#bio-modal').find('.person-company-name');
      const targetPersonCompanyLogoSrc = $('#bio-modal').find('.person-company-logo');

      targetPersonName.html(personName);
      targetPersonPhotoSrc.css('background', personPhotoSrc);
      targetPersonPosition.html(personPosition);
      targetPersonDesc.html(personDesc);
      targetPersonComapnyName.html(personComapnyName);
      if (personCompanyLogoSrc === undefined) {
        targetPersonCompanyLogoSrc.hide();
      } else {
        targetPersonCompanyLogoSrc.show();
        targetPersonCompanyLogoSrc.attr('src', personCompanyLogoSrc);
      }

    });

    $('#jury-section .single-person').click(function() {
      $('#bio-modal').fadeIn();
      $('html').addClass('is-blocked');

      const personName = $(this).find('.person-name').html();
      const personPhotoSrc = $(this).find('.person-photo').css('background-image');
      const personPosition = $(this).find('.person-position').html();
      const personDesc = $(this).find('.person-bio').html();
      const personComapnyName = $(this).find('.person-company-name').html();
      const personCompanyLogoSrc = $(this).find('.person-company-logo').attr('src');

      const targetPersonName = $('#bio-modal').find('.person-name');
      const targetPersonPhotoSrc = $('#bio-modal').find('.person-photo');
      const targetPersonPosition = $('#bio-modal').find('.person-position');
      const targetPersonDesc = $('#bio-modal').find('.person-bio');
      const targetPersonComapnyName = $('#bio-modal').find('.person-company-name');
      const targetPersonCompanyLogoSrc = $('#bio-modal').find('.person-company-logo');

      targetPersonName.html(personName);
      targetPersonPhotoSrc.css('background', personPhotoSrc);
      targetPersonPosition.html(personPosition);
      targetPersonDesc.html(personDesc);
      targetPersonComapnyName.html(personComapnyName);
      if (personCompanyLogoSrc === undefined) {
        targetPersonCompanyLogoSrc.hide();
      } else {
        targetPersonCompanyLogoSrc.show();
        targetPersonCompanyLogoSrc.attr('src', personCompanyLogoSrc);
      }

    });

    $('#networking-section .single-person').click(function() {
      $('#bio-modal').fadeIn();
      $('html').addClass('is-blocked');

      const personName = $(this).find('.person-name').html();
      const personPhotoSrc = $(this).find('.person-photo').css('background-image');
      const personPosition = $(this).find('.person-position').html();
      const personDesc = $(this).find('.person-bio').html();
      const personComapnyName = $(this).find('.person-company-name').html();
      const personCompanyLogoSrc = $(this).find('.person-company-logo').attr('src');

      const targetPersonName = $('#bio-modal').find('.person-name');
      const targetPersonPhotoSrc = $('#bio-modal').find('.person-photo');
      const targetPersonPosition = $('#bio-modal').find('.person-position');
      const targetPersonDesc = $('#bio-modal').find('.person-bio');
      const targetPersonComapnyName = $('#bio-modal').find('.person-company-name');
      const targetPersonCompanyLogoSrc = $('#bio-modal').find('.person-company-logo');

      targetPersonName.html(personName);
      targetPersonPhotoSrc.css('background', personPhotoSrc);
      targetPersonPosition.html(personPosition);
      targetPersonDesc.html(personDesc);
      targetPersonComapnyName.html(personComapnyName);
      if (personCompanyLogoSrc === undefined) {
        targetPersonCompanyLogoSrc.hide();
      } else {
        targetPersonCompanyLogoSrc.show();
        targetPersonCompanyLogoSrc.attr('src', personCompanyLogoSrc);
      }
    });

    // PARTNER modal & SPONSOR modal (same)
    $('.become-partner-btn').click(function() {
      $('#partner-select').val('I want to become a partner').trigger('change');
      $('#partner-select').dropkick('refresh');
      $('#partner-modal').fadeIn();
      $('html').addClass('is-blocked');
    });

    $('.become-a-sponsor-btn').click(function() {
      $('#partner-select').val('I want to become a sponsor').trigger('change');
      $('#partner-select').dropkick('refresh');
      $('#partner-modal').fadeIn();
      $('html').addClass('is-blocked');
    });

    // TICKET modal
    $('.book-ticket-modal-btn').click(function() {
      const ticketName = $(this).data( 'name' );
      const ticketPrice = $(this).data( 'price' );
      const ticketInput = $('#ticket-type')
      const ticketValue = ticketName  + ' - ' + ticketPrice;
      ticketInput[0].value = ticketValue;
      $('#ticket-modal').fadeIn();
      $('html').addClass('is-blocked');
    });

    // NOMINATION modal
    $('.submit-nomination-form-btn').click(function() {
      const categoryName = $(this).data( 'category' );
      const categorySubtitle = $('#nomination-category');
      const nominationFormSource = $(this).parents('.category-box').find('.nomination-form-source > div');
      const nominationFormContainer = $('#nomination-form-container');
      $('#close-nomination-icon').attr( 'data-category', categoryName );
      nominationFormContainer.append(nominationFormSource);

      const categoryInput = $('#nomination-form-container .category-input');
      categorySubtitle[0].innerHTML = categoryName;
      categoryInput[0].value = categoryName;

      $('#nomination-modal').fadeIn();
      $('html').addClass('is-blocked');
    });

    // MODAL UTILITIES - close + backdrop
    $('.close-icon').click(function() {
      $('.modal').fadeOut();
      $('html').removeClass('is-blocked');
      $('.video-embed iframe').each(function() {
        let iframeSrc = $(this).attr('src');
        
        if (iframeSrc && iframeSrc.includes('youtube')) {
          // Store all original attributes
          const originalIframe = $(this);
          const attributes = {};
          $.each(originalIframe[0].attributes, function(_, attr) {
            attributes[attr.name] = attr.value;
          });
          
          // Update src with required parameters
          if (!iframeSrc.includes('enablejsapi=1')) {
            if (iframeSrc.includes('?')) {
              iframeSrc += '&enablejsapi=1&origin=' + window.location.origin;
            } else {
              iframeSrc += '?enablejsapi=1&origin=' + window.location.origin;
            }
          }
          
          // Force video to stop by reloading iframe with autoplay=0
          if (iframeSrc.includes('autoplay=1')) {
            iframeSrc = iframeSrc.replace('autoplay=1', 'autoplay=0');
          } else if (!iframeSrc.includes('autoplay=')) {
            if (iframeSrc.includes('?')) {
              iframeSrc += '&autoplay=0';
            } else {
              iframeSrc += '?autoplay=0';
            }
          }
          
          // Create a new iframe element with all original attributes
          const iframeParent = originalIframe.parent();
          const newIframe = $('<iframe></iframe>');
          
          // Copy all original attributes
          $.each(attributes, function(key, value) {
            if (key !== 'src') { // We'll set src last
              newIframe.attr(key, value);
            }
          });
          
          // Set the updated src
          newIframe.attr('src', iframeSrc);
          
          // Replace the original iframe
          originalIframe.remove();
          iframeParent.append(newIframe);
        }
      });
    });

    let categoryName;
    let formSource;
    let formTarget;

    $('#close-nomination-icon').click(function() {
      categoryName = $('#nomination-category').html();
      formSource = $('#nomination-form-container > div');
      formTarget = $('.nomination-form-source[data-category="' + categoryName + '"]');
      formTarget.append(formSource);
      $('.modal').fadeOut();
      $('html').removeClass('is-blocked');
      $(this).removeAttr('data-category');
    });

    $('.modal-backdrop').click(function() {
      if(typeof $('#close-nomination-icon').attr('data-category') === 'string') {
        categoryName = $('#nomination-category').html();
        formSource = $('#nomination-form-container > div');
        formTarget = $('.nomination-form-source[data-category="' + categoryName + '"]');
        formTarget.append(formSource);
        $('.modal').fadeOut();
        $('html').removeClass('is-blocked');
      } else {
        $('.modal').fadeOut();
        $('html').removeClass('is-blocked');
        $('.video-embed iframe').each(function() {
          let iframeSrc = $(this).attr('src');
          
          if (iframeSrc && iframeSrc.includes('youtube')) {
            // Store all original attributes
            const originalIframe = $(this);
            const attributes = {};
            $.each(originalIframe[0].attributes, function(_, attr) {
              attributes[attr.name] = attr.value;
            });
            
            // Update src with required parameters
            if (!iframeSrc.includes('enablejsapi=1')) {
              if (iframeSrc.includes('?')) {
                iframeSrc += '&enablejsapi=1&origin=' + window.location.origin;
              } else {
                iframeSrc += '?enablejsapi=1&origin=' + window.location.origin;
              }
            }
            
            // Force video to stop by reloading iframe with autoplay=0
            if (iframeSrc.includes('autoplay=1')) {
              iframeSrc = iframeSrc.replace('autoplay=1', 'autoplay=0');
            } else if (!iframeSrc.includes('autoplay=')) {
              if (iframeSrc.includes('?')) {
                iframeSrc += '&autoplay=0';
              } else {
                iframeSrc += '?autoplay=0';
              }
            }
            
            // Create a new iframe element with all original attributes
            const iframeParent = originalIframe.parent();
            const newIframe = $('<iframe></iframe>');
            
            // Copy all original attributes
            $.each(attributes, function(key, value) {
              if (key !== 'src') { // We'll set src last
                newIframe.attr(key, value);
              }
            });
            
            // Set the updated src
            newIframe.attr('src', iframeSrc);
            
            // Replace the original iframe
            originalIframe.remove();
            iframeParent.append(newIframe);
          }
        });
      }
      $('#close-nomination-icon').removeAttr('data-category');
    });

    // EVENT DATE COUNTDOWN
    const eventDate = $('#event-date').attr('data-date');
    countDownToTime(eventDate, 'countdown');

    function countDownToTime(countTo, id) {
      countTo = new Date(countTo).getTime();
      const now = new Date();
      countTo = new Date(countTo);
      const timeDifference = (countTo - now);

      const secondsInADay = 60 * 60 * 1000 * 24;
      const secondsInAHour = 60 * 60 * 1000;

      const days = Math.floor(timeDifference / (secondsInADay) * 1);
      const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
      const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
      const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);

      const daysEl = document.getElementsByClassName('days')[0];
      const hoursEl = document.getElementsByClassName('hours')[0];
      const minsEl = document.getElementsByClassName('minutes')[0];
      const secsEl = document.getElementsByClassName('seconds')[0];

      if (days > 0) {
        daysEl.innerHTML = days;
      } else {
        daysEl.innerHTML = 0;
      }

      if (hours > 0) {
        hoursEl.innerHTML = hours;
      } else {
        hoursEl.innerHTML = 0;
      }

      if (mins > 0) {
        minsEl.innerHTML = mins;
      } else {
        minsEl.innerHTML = 0;
      }

      if (secs > 0) {
        secsEl.innerHTML = secs;
      } else {
        secsEl.innerHTML = 0;
      }

      if ((days==0) && (hours==0) && (mins==0) && (secs==0)) {
        console.log('WATCH LIVE');
      }

      clearTimeout(countDownToTime.interval);
      countDownToTime.interval = setTimeout(function(){ countDownToTime(countTo, id); },1000);
    }

    // SMOOTH SCROLL
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 150,
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
          }
        }
      });

    const headingTop = document.getElementById('top');
    const headingTopDesktopBgURL = headingTop.dataset.desktopbg;
    const headingTopMobileBgURL = headingTop.dataset.mobilebg;
    const titleImage = document.getElementById('title-vector-image');
    const titleImgDesktopURL = titleImage.dataset.desktoptitle;
    const titleImgMobileURL = titleImage.dataset.mobiletitle;

    // RESOLUTION CHANGE RESET ->>> MOBILE
    function resetToMobile() {
      headingTop.style.background = 'url(' + headingTopMobileBgURL + ')';
      titleImage.src = titleImgMobileURL;
    }

    // RESOLUTION CHANGE RESET ->>> DESKTOP
    function resetToDesktop() {
      headingTop.style.background = 'url(' + headingTopDesktopBgURL + ')';
      titleImage.src = titleImgDesktopURL;
    }

    function initResolution() {
      width = $(window).width();
      if (width > 1000) {
        resetToDesktop();
      } else {
        resetToMobile();
      }
    }

    // WINDOWS RESIZE -> WIDTH CHANGE ONLY
    let width = $(window).width();
    $(window).on('resize', function () {
      if ($(this).width() != width) {
        width = $(this).width();
        //RESET ON RESIZE
        if (width > 1000) {
          resetToDesktop();
        } else {
          resetToMobile();
        }
      }
    });

    initResolution();

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js